/**
 * Created by sagil on 09/10/2016.
 */
import {Component, EventEmitter, HostBinding, Input, OnChanges, OnInit, Output} from "@angular/core";
import {PopupComponent} from "../popup.component/popup.component";

export type MessageLevel = "Warning" | "Error"|"Info";

@Component({
	selector: 'cp-info-popup',
	styleUrls: ['./info.popup.component.scss'],
	template: `
	<cp-popup class="disable-popup-backround" [label]="label" [resizable]="false" [disposable]="false" [width]="width + 'px'" [autoHeight]="true" (close)="onClose()"
			  [autoHeightAutoReCalc]="messagesHeightChanges">
		<div class="popup-container">
			<i class="icon-place-holder cp-icon-"></i>
			<div class="popup-seperator"></div>
			<ng-content select=".popup-text"></ng-content>
		</div>
		<ng-content select=".popup-buttons"></ng-content>


		<div class="generic">
			<ng-content></ng-content>
		</div>
	</cp-popup>`
})
export class InfoPopupComponent implements OnChanges, OnInit{
	@Output() close = new EventEmitter();
	@Input() level:MessageLevel="Info";
	@Input() messagesHeightChanges:boolean=false;

	@Input() customLabel: string;
	@Input() width: number;

	public label:string;

	ngOnInit(): void {
		this.label = this.customLabel||this.level;
		this.width = this.width || 420;
	}

	ngOnChanges(){
		this.label = this.customLabel||this.level;
	}

	onClose() {
		this.close.emit(null);
	}
	@HostBinding("class.error")
	public get isErrorLevel(){
		return this.level==="Error";
	}
	@HostBinding("class.warn")
	public get isWarnLevel(){
		return this.level==="Warning";
	}
	@HostBinding("class.info")
	public get isInfoLevel(){
		return this.level==="Info";
	}
}
